import { DriverRegistrationPortalNoAuthService } from '@gen/driverRegistration/driverRegistrationPortalNoAuth';

const normalizeLanguageTag = (tag: string): string =>
  tag.trim().replace(/_/g, '-').toLowerCase();

const primarySubtagOfNormalizedTag = (normalizedTag: string): string =>
  normalizedTag.split('-').filter(Boolean)[0] ?? '';

export const pickSupportedLanguageKey = (
  requested: string,
  supported: DriverRegistrationPortalNoAuthService.FlowLanguage[]
): string => {
  if (supported.length === 0) {
    return requested;
  }

  const reqNorm = normalizeLanguageTag(requested);
  if (!reqNorm) {
    return supported[0].key;
  }

  const exact = supported.find((l) => l.key.toLowerCase() === reqNorm);
  if (exact) {
    return exact.key;
  }

  const reqPrimary = primarySubtagOfNormalizedTag(reqNorm);
  if (!reqPrimary) {
    return supported[0].key;
  }

  const candidates = supported.filter(
    (l) =>
      primarySubtagOfNormalizedTag(normalizeLanguageTag(l.key)) === reqPrimary
  );

  if (candidates.length === 0) {
    return supported[0].key;
  }

  if (candidates.length === 1) {
    return candidates[0].key;
  }

  const barePrimary = candidates.find(
    (l) => normalizeLanguageTag(l.key) === reqPrimary
  );
  if (barePrimary) {
    return barePrimary.key;
  }

  return candidates[0].key;
};
